<template>
  <v-dialog
    v-model="enable"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-container>
        <v-card-title
          class="headline px-0"
        >
          Link Corporate
        </v-card-title>
        <v-card-text class="px-2">
          <v-form
            id="form_register"
            ref="form"
            v-model="isValid"
            lazy-validation
          >
            <v-flex>
              <v-autocomplete
                id="link_corporate"
                v-model="req.corporateId"
                :items="corporates"
                item-text="name"
                item-value="id"
                label="Corporate"
                clearable
                open-on-clear
              />
            </v-flex>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div>
            <small style="font-weight:400;margin-right: 4px;">
              *indicates required field</small>
          </div>
          <v-spacer />
          <v-btn
            id="register_close"
            color="error"
            class="white--text"
            @click.native="close()"
          >
            Close
          </v-btn>
          <v-btn
            id="register_save"
            color="success"
            class="white--text"
            :disabled="!isValid "
            :loading="loader"
            @click.native="linkCorporate()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
	name: "LinkCorporate",
	props: {
		showDialog: {
			type: Boolean,
			default: false
		},
		accountId: {
			type: Number,
			required: true
		},
		corporateId: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			isValid: false,
			loader: false,
			req: {
				accountId: null,
				corporateId: null
			},
			corporates: []
		};
	},
	computed: {
		enable: {
			get() {
				return this.showDialog;
			},
			set(val){
				console.log({val});
			}
		}
	},
	watch: {
		enable(v) {
			if (v) {
				this.req.corporateId = this.corporateId;
				this.getcorporates();
			}
		}
	},
	methods: {
		close() {
			this.$emit("update:showDialog", false);
			this.$emit("refresh");
			this.clear();
		},
		linkCorporate: function () {
			if (!this.$refs.form.validate()) {
				return;
			}
			this.loader = true;
			this.req.accountId = this.accountId;
			this.$http.put(`${this.ADMIN_API_URL}/linkCorporate`, this.req).then(
				function (data) {
					this.loader = false;
					this.close();
					this.$store.commit("showSnackbar", {
						timeout: 3000,
						message: data.body.message
					});
				},
				function (failure) {
					this.loader = false;
					this.handleFailure(failure);
				}
			);
		},
		getError(key) {
			return this.errors && this.errors[key] ? [this.errors[key]] : [];
		},
		dirtyError(key) {
			this.errors[key] = "";
		},
		handleFailure: function (failure) {
			let msg = failure.body.message || "Error";
			let errors = failure.body.errors;
			if (errors && errors.Name) {
				msg = errors.Name;
			}
			this.$store.commit("showSnackbar", {
				message: msg,
				color: "error"
			});
		},
		clear() {
			this.errors = {};
			this.$refs.form.reset();
		},
		getcorporates: function () {
			this.$http.get(`${this.ADMIN_API_URL}/corporateMasters`).then(function (data) {
				this.corporates = data.body;
			});
		}
	}
};
</script>